module.exports = __webpack_public_path__ + "img/function1-2.abb7f1cc.svg";